export default "__VITE_ASSET__DvKJNSI8__"